<mapfre-modal
  [modalOptions]="uploadingFiles"
  [hideModal]="hideModalOnRoute"
  (closeModal)="resetHideModal($event)"
>
  <div class="modal-body no-margin-top margin-bottom mb8 remove-file-modal">
    <ng-container *ngIf="isAcmic; else maHeader">
      <hr class="margin-bottom mb16 no-margin-top"/>                              
    </ng-container>
    <ng-template #maHeader>
      <div class="ma-modal-title">{{'Remove file' | translate}}</div>                                                                
    </ng-template>
    <div class="uploading-files margin-top mt24 text-center">
      <div>
        <img src="./assets/img/images/icon-title-delete.svg" alt="delete icon"/>
      </div>
      <div class="document-message margin-top mt16">
        {{ "Are you sure you want to remove" }}
      </div>
      <div class="document-message doc-name">
        <div>{{ uploadedFile }}</div>
        <div>{{ " file?" }}</div>        
      </div>
    </div>
    <hr class="ma-hr-tag" *ngIf="!isAcmic"> 
    <div class="show-btn-order text-right margin-bottom mb16 margin-top mt24">
      <mapfre-button
        (click)="onClickCancel()"
        additionalClasses="ghost secondary small-btn modal-small-btn letter-space-17"
        >{{ "CANCEL" | translate }}
      </mapfre-button>
      <mapfre-button
        (click)="onClickRemove()"
        additionalClasses="basic primary small-btn margin-bottom modal-small-btn letter-space-17"
      >
        {{ "Remove" | translate }}
      </mapfre-button>
    </div>
  </div>
</mapfre-modal>
